import ShareBtn from './ShareBtn'

export default ShareBtn



// WEBPACK FOOTER //
// ./src/components/ShareButton/index.js